import { CloseOutlined } from '@ant-design/icons';
import { FC } from 'react';
import GlassIcon from '../../assets/images/searchBar/glassIcon';
import './SearchBar.scss';

interface ISearchBar {
  searchText?: string;
  customPlaceholder?: string;
  setSearchText?: (text: string) => void;
  loadingSearchBar?: boolean;
}

const SearchBar: FC<ISearchBar> = ({ searchText, setSearchText, customPlaceholder, loadingSearchBar }: ISearchBar) => {
  const handleText = (text: string) => setSearchText?.(text);

  return (
    <div
      id="searchBar"
      className={`${loadingSearchBar ? 'disabledStyles' : ''}`}
      style={{ border: searchText ? 'black 1px solid' : '', cursor: loadingSearchBar ? 'wait' : '' }}
    >
      <div className="containerIcon">
        <GlassIcon className="glassIcon" stroke={searchText ? 'black' : ''} />
      </div>
      <div className="containerInput">
        <input
          disabled={loadingSearchBar}
          style={{ cursor: loadingSearchBar ? 'wait' : '' }}
          onChange={e => handleText(e.target.value)}
          value={searchText}
          placeholder={customPlaceholder || 'Buscar'}
          className="inputStyle"
        />
      </div>
      <div className="containerIcon">
        {searchText && (
          <CloseOutlined onClick={() => handleText('')} className={`${!searchText ? 'styleIcon' : 'disabledIcon'}`} />
        )}
      </div>
    </div>
  );
};

export default SearchBar;
